import React, {memo, useState} from 'react';
import {useDispatch} from 'react-redux';
import {AppDispatch} from '~/redux/root-store';
import {AppDropzone, AppModal, UiBox, UiButton, UploadResponse} from '~/components/elements';

interface Props {
  isShowing: boolean;
  onDismissModal: () => void;
  onSuccessUpload: (arg: any) => void;
  multiple?: boolean;
  limit?: number;
  endpoint?: string;
}

const UploadImageModal = ({isShowing, onDismissModal, onSuccessUpload, multiple, limit, endpoint, ...rest}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const [file, setFile] = useState<UploadResponse[]>([]);
  const onCloseModal = () => {
    setFile([]);
    onDismissModal();
  };

  const onClickSubmit = async (e: React.FormEvent) => {
    onSuccessUpload(file);
    setFile([]);
    onCloseModal();
  };

  const saveFile = (arg: any) => {
    setFile(arg);
  };

  const onRemoveFile = (f: UploadResponse) => {
    setFile(file.filter(item => item.accessUrl !== f.accessUrl));
  };

  const renderActions = () => <UiButton title="Save" disabled={!file.length} onClick={onClickSubmit} />;

  return !isShowing ? null : (
    <AppModal
      actions={renderActions()}
      isOpen={isShowing}
      onClose={onCloseModal}
      contentMinW="60%"
      autoFocus={false}
      isCentered
      hideSubmit
    >
      <UiBox mt={5}>
        <AppDropzone
          type="nric_photo"
          onSuccess={saveFile}
          acceptType={['IMAGE']}
          onRemove={onRemoveFile}
          multiple={multiple}
          limit={limit}
          endpoint={endpoint}
          useLocalUrl
          {...rest}
        />
      </UiBox>
    </AppModal>
  );
};

export default memo(UploadImageModal);
